<template lang='pug' src='./custom-percent-section.pug'></template>

<script>
import VueTrigger from 'components/block/block-vue-trigger/block-vue-trigger'

export default {
  props: ['props'],
  methods: {
    percentTrigger () {
      this.$store.dispatch('VIEW_BODY', 1)
    },
    googleIt () {
      this.$store.dispatch('VIEW_DEFAULT', false)
    }
  },
  components: {
    VueTrigger
  }
}
</script>



// WEBPACK FOOTER //
// custom-percent-section.vue?7056da45